/**
 * Expand and collapse component
 */

import initialiser from '../../utils/initialiser';

const defaultSettings = {
  hidden: 'u-none',
  expanded: 'is-expanded',
};

class ExpandCollapse {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;
    this.cards = [...el.querySelectorAll(settings.cards)];
    this.trigger = el.querySelector(settings.trigger);
    this.triggerLabel = el.querySelector(settings.triggerLabel);
    this.triggerLabelTextOriginal = this.triggerLabel ? this.triggerLabel.textContent : '';
    this.triggerLabelTextOnExpand = settings.triggerLabelTextOnExpand;
    this.limit = settings.limit;
    this.increment = settings.increment;
    this.settings = { ...defaultSettings, ...settings };
  }

  init = () => {
    if (!this.container || !this.trigger || !this.triggerLabel) return;

    this.initialise();

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    this.trigger.addEventListener('click', this.handleClick);
  };

  handleClick = (e) => {
    e.preventDefault();
    this.showHiddenCards();
    this.hideCardsOnClick();
    this.updateTriggerLabel();
  };

  updateTriggerLabel = () => {
    const hiddenCards = [...this.container.querySelectorAll(`.${this.settings.hidden}`)];

    if (hiddenCards.length === 0) {
      this.triggerLabel.textContent = this.triggerLabelTextOnExpand;
      this.container.classList.add(this.settings.expanded);
    } else {
      this.container.classList.remove(this.settings.expanded);
      this.triggerLabel.textContent = this.triggerLabelTextOriginal;
    }
  };

  hideCards = () => {
    this.cards.forEach((card, index) => {
      if (index >= this.limit) {
        card.classList.add(this.settings.hidden);
      }
    });
  };

  hideCardsOnClick = () => {
    if (this.container.classList.contains(this.settings.expanded)) {
      this.hideCards();
      this.container.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  showHiddenCards = () => {
    const hiddenCards = [
      ...this.container.querySelectorAll(`.${this.settings.hidden}`)];

    hiddenCards.forEach((card, index) => {
      // show next row
      if (index < this.increment) {
        card.classList.remove(this.settings.hidden);
      }
    });
  };

  initialise = () => {
    // fall back if template does not handle
    if (this.cards.length <= this.limit) {
      this.container.classList.add(this.settings.expanded);
      this.trigger.classList.toggle(this.settings.hidden);
    }
  };
}

export default (settings) => initialiser(settings, ExpandCollapse);
